<template>
    <div
        class="report-filters flex-row ai-center white-bkg bl-1 bt-1 br-1 jc-space px-3 py-3 br br-bottom-0"
    >
        <div>
            <TimelineAuthorFilter :selected="authors" @input="selectStaff" />
        </div>
        <div class="report-filters-datepicker">
            <el-date-picker
                ref="reportFiltersDatePicker"
                v-model="dates"
                type="daterange"
                class="wp-10 py-0"
                :format="datePickerFormat"
                :shortcuts="shortcuts"
                :startPlaceholder="$t.__('common.labels.start_date')"
                :endPlaceholder="$t.__('common.labels.end_date')"
                :clearable="false"
                @update:modelValue="updateDates"
            >
            </el-date-picker>
        </div>
        <div class="report-filters-mode">
            <el-select
                v-if="isActiveDisplayMode"
                :modelValue="periodSelected"
                popperClass="report-filters-select__popper"
                class="report-filters-select"
                @change="updatePeriod"
            >
                <el-option
                    v-for="period in periods"
                    :key="period.id"
                    :ref="`reportFiltersSelectPopperOptions${
                        periodSelected === period.id ? 'Selected' : ''
                    }`"
                    :value="period.id"
                    :label="period.label"
                    :disabled="isPeriodDisable(period)"
                ></el-option>
            </el-select>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import TimelineAuthorFilter from 'vcomponents/timeline/TimelineAuthorFilter.vue';

const corpStore = createNamespacedHelpers('corp');
const reportStore = createNamespacedHelpers('report');

export default {
    components: {
        TimelineAuthorFilter,
    },
    data() {
        return {
            dates: [],
            shortcuts: [
                {
                    text: this.$l10n.__('Hier'),
                    value: () => {
                        const start = new moment().startOf('day').subtract(1, 'day');
                        const end = new moment().endOf('day').subtract(1, 'day');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Semaine dernière'),
                    value: () => {
                        const start = new moment().startOf('week').subtract(1, 'weeks');
                        const end = new moment().endOf('week').subtract(1, 'weeks');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Ce mois'),
                    value: () => {
                        const start = new moment().startOf('month');
                        const end = new moment().endOf('month');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Le mois dernier'),
                    value: () => {
                        const start = new moment().startOf('month').subtract(1, 'months');
                        const end = new moment().endOf('month').subtract(1, 'months');
                        this.updateDates([start.toDate(), end.toDate()]);
                    },
                },
                {
                    text: this.$l10n.__('Les 3 derniers mois'),
                    value: () => {
                        const start = new moment().startOf('month').subtract(3, 'months');
                        const end = new moment().endOf('month').subtract(1, 'months');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Ce trimestre'),
                    value: () => {
                        const start = new moment().startOf('quarter');
                        const end = new moment().endOf('quarter');
                        this.updateDates([start.toDate(), end.toDate()]);
                    },
                },
                {
                    text: this.$l10n.__('Trimestre dernier'),
                    value: () => {
                        const start = new moment().startOf('quarter').subtract(1, 'quarter');
                        const end = new moment().endOf('quarter').subtract(1, 'quarter');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Cette année'),
                    value: () => {
                        const start = new moment().startOf('year');
                        const end = new moment().endOf('year');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
                {
                    text: this.$l10n.__('Année dernière'),
                    value: () => {
                        const start = new moment().startOf('year').subtract(1, 'years');
                        const end = new moment().endOf('year').subtract(1, 'years');
                        this.updateDates([start.toDate(), end.toDate()]);
                        this.$refs.reportFiltersDatePicker?.handleClose();
                    },
                },
            ],
        };
    },
    computed: {
        ...corpStore.mapGetters(['datePickerFormat']),
        ...reportStore.mapGetters(['periodSelected', 'periods', 'embed', 'filters', 'authors']),
        isActiveDisplayMode() {
            return this.$route.params.type === 'all';
        },
    },
    updated() {
        //Check that filters dates are different from this.dates to avoid update everytime and update only when necessary
        if (
            this.filters.due_date.start !== this.dates[0] ||
            this.filters.due_date.end !== this.dates[1]
        ) {
            this.dates = [this.filters.due_date.start, this.filters.due_date.end];
        }
    },
    mounted() {
        this.updateHoverDisplayMode();
    },
    methods: {
        /**
         * Get staff on filters select
         * event: type of filter
         * staffs: array of staff ids
         */
        selectStaff(event, staffs) {
            this.$store.dispatch('report/updateFilters', {
                ...this.filters,
                authors: staffs.length ? staffs : null,
            });
        },
        /**
         * Update dates range
         * dates: array of dates
         * Update Period aggregation by first period available in new daterange
         */
        updateDates(dates) {
            if (this.isPeriodDisable({ id: this.periodSelected })) {
                const periodSelected = this.periods.find(
                    (period) => !this.isPeriodDisable(period),
                ).id;
                this.updatePeriod(periodSelected);
            }

            /**
             * We need to take the date between the first date at 00:00 and the second date at 23:59:59
             * Otherwise for the same date picking we will have no value returned
             */
            dates[0].setHours(0, 0, 0);
            dates[1].setHours(23, 59, 59);

            this.$store.dispatch('report/updateFilters', {
                ...this.filters,
                due_date: { start: dates[0], end: dates[1] },
            });
        },
        updatePeriod(period) {
            this.$store.dispatch('report/updatePeriodSelected', period);
            this.updateHoverDisplayMode();
        },
        /**
         * Disable Period Option based on duration (days) between selected dates
         * period : { id: string, label: string }
         * Options
         * Period < 7 : D
         * Period > 7 && Period < 30 : D/W
         * Period > 30 && Period < 90 : D/W/M
         * Period > 90 && Period < 365 : W/M/Q
         * Period > 365 : M/Q/Y
         */
        isPeriodDisable(period) {
            const currentPeriod = moment(this.dates[1]).diff(moment(this.dates[0]), 'days') + 1;
            switch (period.id) {
                case 'day':
                    return currentPeriod > 90;
                case 'week':
                    return currentPeriod < 7 || currentPeriod >= 365;
                case 'month':
                    return currentPeriod < 30;
            }
        },
        /**
         * Force the hover state of the selected option of the display mode select
         */
        updateHoverDisplayMode() {
            if (!this.isActiveDisplayMode || !this.periods.includes(this.periodSelected)) return;

            setTimeout(() => {
                const reportFiltersSelectPopperOptionsSelected =
                    this.$refs.reportFiltersSelectPopperOptionsSelected.shift();
                reportFiltersSelectPopperOptionsSelected.hoverItem();
            });
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.report-filters {
    // Select
    .report-filters-mode {
        min-width: 176px;
    }
    .report-filters-select {
        .el-input__inner {
            padding-left: 12px;
        }
        .el-select__caret.el-input__icon.el-icon-arrow-up {
            color: $gray-100;
        }
    }
    // Arrow Select & Cascader
    .el-input__suffix {
        right: 6px;
    }
    // DatePicker
    .report-filters-datepicker {
        width: auto;
        .el-date-editor.el-date-editor--daterange,
        .el-date-editor.el-range-editor {
            flex-wrap: wrap;
            padding: 0 12px;
        }
        .el-input__icon.el-range__icon.el-icon-date {
            color: $gray-100;
            margin-left: 0;
            margin-right: 8px;
            width: auto;
        }
        .el-range-input {
            width: 75px;
            padding: 0;
        }
        .el-range-separator {
            height: 1px;
            width: 14px;
            padding: 0;
            margin: 0 8px;
            border-bottom: 1px solid $gray-60;
            color: transparent;
        }
        .el-range__close-icon {
            display: none;
        }
    }
}
</style>
